module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a86b4d64aa3808530d545e9d6442406d.png";